<div class="allcp-form mw400 auth-page login-panel" id="login" ng-submit="login(loginForm)">
	<a href="/" target="__BLANK">
		<img src="/landing/img/logo.svg" alt="HODXpress Login" class="img img-responsive auth-logo">
	</a>
	<div class="panel mw400">
	    <div class="panel-body pn mv10">
			<form method="post" id="loginForm">
				<input type="hidden" name="_token" value="<% csrf_token() %>" />
					<div class="section">
						<label for="email" class="field">
							<input type="text" name="email" id="email" class="gui-input" placeholder="E-Mail..." ng-model="loginForm.email" required>
						</label>
					</div>
					<div class="section">
						<label for="password" class="field show-hide-pass">
							<input type="{{inputType}}" name="password" id="password" class="gui-input" placeholder="Password..." ng-model="loginForm.password" required>
							<a href="" ng-click="hideShowPassword()">
								<i ng-if="inputType == 'password'" class="fa fa-eye-slash"></i>
								<i ng-if="inputType == 'text'" class="fa fa-eye"></i>
							</a>
						</label>
					</div>
					<div class="section">
						<div class="bs-component pull-left pt5">
							<a href="/forgot">Forgot my password</a>
						</div>
						<button type="submit" class="hod-button orange pull-right">Login</button>
					</div>
					<div class="clearfix"></div>
			</form>
		</div>

		<div class="panel-footer">
			<p>
				Don't you have an account. <a href="/partner" target="_blank">Get started Today!</a>
			</p>
		</div>
	</div> 
	<img src="/img/box.svg" alt="HODXpress Login" class="auth-page-box">
	<img src="/img/boxes.svg" alt="HODXpress Login" class="auth-page-boxes">
	<br> <br>
	<div class="col-md-12 text-center footer-copy">
		<p>© 2024 HODXpress</p>
	</div>
</div>